/* import __COLOCATED_TEMPLATE__ from './edit-mcp-server-modal.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

interface Args {
  onModalClose: () => void;
  mcpServerId: string | null;
  onDeleteMcpServerClick: () => void;
}

export default class EditMcpServerModal extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare store: $TSFixMe;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
  }

  get mcpServerId() {
    return this.args.mcpServerId;
  }

  get mcpServer() {
    return this.store.peekRecord('workflow-connector/mcp-server', this.mcpServerId);
  }

  get serverName() {
    return this.mcpServer?.name || '';
  }

  get serverUrl() {
    return this.mcpServer?.url || '';
  }

  get serverDescription() {
    return this.mcpServer?.description || '';
  }

  get serverIcon() {
    return this.mcpServer?.icon;
  }

  @action
  openDeleteMcpServerModal() {
    this.args.onModalClose();
    this.args.onDeleteMcpServerClick();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::EditMcpServerModal': typeof EditMcpServerModal;
    'workflow-connector/edit-mcp-server-modal': typeof EditMcpServerModal;
  }
}
